import { z } from "zod";
export const CommunityDevSeedResponse = z.object({
    ok: z.literal(true),
    seeded: z.object({
        coworkers: z.number().int().nonnegative(),
        moments: z.number().int().nonnegative(),
        kudos: z.number().int().nonnegative(),
        reactions: z.number().int().nonnegative(),
        reports: z.number().int().nonnegative(),
        milestones: z.number().int().nonnegative(),
        images: z.number().int().nonnegative(),
        skippedImages: z.number().int().nonnegative(),
        recipeUnresolved: z.boolean(),
    }),
});
//# sourceMappingURL=demo.js.map